import { Form, Formik } from 'formik';
import { useGenerateLicenseCodesApi } from '../../../api/license-code-api';
import { ProductDTO } from '../../../api/product-api';
import SvgDownload from '../../../assets/icons/Download';
import { BasicModal } from '../../../components/basic/basic-modal';
import { T, translate } from '../../../components/basic/text';
import { yup } from '../../../components/basic/yup';
import { FormikTextField } from '../../../components/formik';
import { LoadingButton } from '../../../components/loading-button';
import { notify } from '../../../components/basic/notify';

export const GenerateLicenseCodeBulkModal = ({
    show,
    products,
    onHide,
}: {
    show: boolean;
    products: ProductDTO[];
    onHide: () => void;
}) => {
    const generateLicenseCodes = useGenerateLicenseCodesApi();
    const handleSubmit = (values: any) => {
        generateLicenseCodes.post(
            null,
            {
                productId: values.productId,
                count: values.count,
            },
            onHide,
            notify.error
        );
    };
    const { busy } = generateLicenseCodes;
    return (
        <Formik
            initialValues={{ count: 100, productId: 0 }}
            validationSchema={yup.object({
                count: yup
                    .number()
                    .min(1)
                    .max(1000)
                    .required(
                        translate('count-must-be-less-than-or-equal-to-@count', {
                            count: 1000,
                        })
                    ),
                productId: yup.number().notOneOf([0], ' ').required(' '),
            })}
            onSubmit={handleSubmit}
        >
            <BasicModal show={show} title={<T>generate-license-code-bulk</T>} onHide={onHide}>
                <Form>
                    <FormikTextField
                        name="productId"
                        label={<T>product</T>}
                        type="select"
                        required
                        items={[
                            { id: 0, title: ' ' },
                            ...products.map(p => ({ id: p.id, title: p.name })),
                        ]}
                    />
                    <FormikTextField
                        name="count"
                        label={<T>count</T>}
                        type="number"
                        required
                        min={1}
                        max={1000}
                    />
                    <LoadingButton
                        className="min-w-80"
                        type="submit"
                        variant="contained"
                        size="sm"
                        label={<T>generate</T>}
                        icon={<SvgDownload />}
                        loading={busy}
                    />
                </Form>
            </BasicModal>
        </Formik>
    );
};
